import React from "react";
import classNames from "classnames";
import { isNil } from "lodash";

export const ThreatTag = ({ count, title, className }) => {
  return (
    <div className={classNames(`d-flex align-items-center threat-tag m-l-xs ${className}`)} style={{maxWidth: "270px"}}>
      <span className="m-0">
        {title}
      </span>
      {!isNil(count) && <span
        className="m-0 h-100 count text-ellipsis"
        title={count}
      >
        {/* for MandiantAdvantage tool, tag value is in boolean from response */}
        {/* Coerced into the string primitive "true"/"false" */}
        {String(count)}
      </span>}
    </div>
  );
};
